const AddCard = () => import("@/components/BankCard/AddCard/index");
export default {
  name: "not-available-card",
  components: { AddCard },
  props: [],
  data() {
    return {
      addCardDialog: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    checkOutCard() {
      this.$emit("confirmOrder", false);
      this.addCardDialog = true;
    }
  }
};
